import consumer from './consumer';

 // Initializes a subscription to specified channel
export const initChannelConnection = (options = {}) => {
  let subscription = null;
  const channelAttrs = {
    channel: options.channel,
    stream_key: options.streamKey,
    organization_id: options.organizationId,
    user_id: options.userId,
    record_id: options.recordId,
  }
  const createSubscription = () => consumer.subscriptions.create(channelAttrs, {
    connected() {
      options.onConnected && options.onConnected()
    },
    received(data) {
      options.onReceived && options.onReceived(data)
    },
  });
  const findSubscription = () => {
    return consumer.subscriptions.subscriptions
      .find(sub => sub.identifier === JSON.stringify(channelAttrs)) || null;
  }
  const connect = () => {
    unsubscribe();
    subscription = createSubscription();

    return subscription;
  };
  const unsubscribe = () => {
    subscription || (subscription = findSubscription());

    if (subscription && consumer.subscriptions.subscriptions.includes(subscription)) {
      subscription.unsubscribe();
    }

    return true;
  }

  subscription = connect();

  return {
    subscription,
    options,
    connect,
    unsubscribe
  };
};
